export const PAGE_SIZE = 7;
export const CARDS_PAGE_SIZE = 10;

export const AVATAR_BASE_URL =
  "https://lasu-profile-avatars.s3.eu-central-1.amazonaws.com";
export const IMAGE_BASE_URL =
  "https://s3.eu-central-1.amazonaws.com/lasu-images.lasudev.com";
export const VIDEO_BASE_URL =
  "https://s3.eu-central-1.amazonaws.com/lasu-videos.lasudev.com";
